import ListingItem from './ListingItem';

const ListingSection = props => (
  <ListingItem bordered={props.bordered}>{props.children}</ListingItem>
);

ListingSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: ListingItem.propTypes.children,
  bordered: ListingItem.propTypes.bordered
};

export default ListingSection;
